/**
 * Combined Observations tour: list view → click a row → detail view.
 *
 * Primary tour for users who already have at least one observation —
 * walks the entire feature in one continuous run. The transition step
 * (``combinedTableStep``) clicks the first row, navigates to the detail
 * page, and waits for it to mount before the detail steps take over.
 *
 * For users with no observations yet, see ``list.ts``. For users who
 * land on a detail page directly without coming through this combined
 * flow, see ``detail.ts``. ``ObservationsPage`` / ``ObservationDetail``
 * pick which one is appropriate based on ``hasSeen`` + project state.
 */
import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { OBSERVATIONS_LIST_TOUR_ID } from './list';
import { OBSERVATIONS_DETAIL_TOUR_ID } from './detail';
import {
  attachmentsStep,
  combinedTableStep,
  descriptionStep,
  filtersStep,
  headerActionsStep,
  metadataStep,
  newObservationStep,
  peopleStep,
  safetyStep,
  statusChartStep,
} from './steps';

export const OBSERVATIONS_COMBINED_TOUR_ID = 'observations.combined';

registerTour({
  id: OBSERVATIONS_COMBINED_TOUR_ID,
  name: 'Observations',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.OBSERVATIONS.id,
  // Completing the combined tour also marks list-only and detail-only
  // tours as seen — they cover the same content this tour walked.
  alsoMarks: [OBSERVATIONS_LIST_TOUR_ID, OBSERVATIONS_DETAIL_TOUR_ID],
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Observations',
      body:
        'Document safety, quality, and site condition findings. We\u2019ll ' +
        'walk through the list view and then dive into one observation.',
    },
    newObservationStep,
    statusChartStep,
    filtersStep,
    combinedTableStep,
    headerActionsStep,
    metadataStep,
    descriptionStep,
    attachmentsStep,
    peopleStep,
    safetyStep,
  ],
});
